import { getRuntime } from 'src/platform/runtime';
import 'src/features/app-exit/components/blocking-screen-exit.css';
import { bindEmergencyExit } from 'src/features/app-exit/emergency-exit';

/** Static boot host only. React owns its controls once it replaces the static shell. */
export function initializeStartupExit(root = document.getElementById('root')) {
  if (!root || !getRuntime().capabilities.appExit) return () => undefined;
  let host: Element | null = null;
  let observer: MutationObserver | undefined;
  let unbind: (() => void) | undefined;
  const attach = () => {
    const next = root.querySelector('#pc-boot-shell, #pc-boot-failure');
    if (next === host) return;
    unbind?.();
    host = next;
    if (!host) {
      observer?.disconnect();
      return;
    }
    const actions = document.createElement('div');
    actions.className = 'pc-screen-exit pc-screen-exit--overlay';
    actions.dataset.tone = 'dark';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pc-screen-exit__button';
    const message = document.createElement('span');
    message.className = 'pc-screen-exit__status';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    actions.append(button, message);
    host.append(actions);
    unbind = bindEmergencyExit(button, message);
  };
  attach();
  observer = new MutationObserver(attach);
  observer.observe(root, { childList: true, subtree: true });
  return () => {
    observer.disconnect();
    unbind?.();
  };
}
